<template>
  <nav class="nav">
    <div class="nav_title">{{ title }}</div>
    <button class="button nav_back" @click="navBack">
      <img class="nav_back" src="../../assets/nav/icon_back.png" />
    </button>
    <button
      class="button nav_rule"
      v-if="right1Items != null"
      @click="$emit('right1action')"
    >
      <img class="nav_image" src="../../assets/lottery/rule_icon.png" />
    </button>
    <button
      class="button nav_customer_service"
      v-if="right2Items != null"
      @click="$emit('right2action')"
    >
      <img class="nav_image" src="../../assets/lottery/service_icon.png" />
    </button>
  </nav>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
@Options({
  props: {
    title: String,
    right1Items: String,
    right2Items: String
  },
  emits: {
    right1action: () => {
      return true;
    },
    right2action: () => {
      return true;
    }
  }
})
export default class Nav extends Vue {
  navBack() {
    // this.$router.go(-1);
    this.$router.back();
  }
}
</script>

<style scoped lang="less">
.nav {
  margin: 0px auto;
  width: 100%;
  height: 44px;
  padding-top: 10px;
  padding-bottom: 10px;
  .nav_back {
    margin-left: 10px;
    height: 25px;
    width: 25px;
    float: left;
  }
  .nav_title {
    left: 30%;
    right: 30%;
    position: absolute;
    font-size: 17px;
    text-align: center;
    align-content: center;
  }
  .nav_customer_service {
    height: 30px;
    width: 30px;
    float: right;
    margin-right: 15px;
  }
  .nav_rule {
    height: 30px;
    width: 30px;
    float: right;
    margin-right: 15px;
  }
  .nav_line {
    margin: 0px auto;
    padding: 0px auto;
    height: 0.5px;
    background-color: #eeeeee;
  }
  .nav_image {
    height: 24px;
    width: 24px;
  }
}
</style>
